import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUnitTestApi } from "../../end-points/unitTest";
import { toast } from "react-toastify";

const initialState = {
  showUnitTest: false,
  showOverview: false,
  loading: false,
  unitTest: null
}

export const getUnitTest = createAsyncThunk(
  "unitTest/getUnitTest", getUnitTestApi
)

export const unitTestSlice = createSlice({
  name: "unitTest",
  initialState,
  reducers: {
    setShowUnitTest: (state, action) => {
      state.showUnitTest = action.payload;
      if (action.payload === true) {
        state.showOverview = false;
      }
    },
    setShowOverview: (state, action) => {
      state.showOverview = action.payload;
      if (action.payload === true) {
        state.showUnitTest = false;
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getUnitTest.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
    })
    builder.addCase(getUnitTest.fulfilled, (state, action) => {
      console.log("Success...", state, action);
      state.unitTest = action.payload;
      state.showUnitTest = true;
      state.showOverview = false;
      state.loading = false;
      console.log("UnitTest", state.unitTest);
    })
    builder.addCase(getUnitTest.rejected, (state, action) => {
      console.log("Error", state, action);
      toast.error(action.error.message)
      state.loading = false;
    })
  }

})

// Action creators are generated for each case reducer function
export const { setShowUnitTest, setShowOverview } = unitTestSlice.actions;

export default unitTestSlice.reducer